import { forEach, propIs, equals, filter, reduce, pluck, pipe, propEq, find, head, prop, flatten, both, contains, complement, anyPass, match, empty } from 'ramda'
import moment from 'moment-timezone'

const getSelected = filter(propEq('selected', true))

const mask = (a, b) => a | b

const encodeDayMask = pipe(
  getSelected,
  pluck('value'),
  reduce(mask, 0)
)

const decodeDayMask = (dayMask, days) => {
  forEach((day) => {
    if (equals(day.value & dayMask, day.value)) {
      day.selected = true
    }
  }, days)
}

const dayNames = {
  'Su': 'Sunday',
  'M': 'Monday',
  'T': 'Tuesday',
  'W': 'Wednesday',
  'Th': 'Thursday',
  'F': 'Friday',
  'S': 'Saturday'
}

class manageDetailsCtrl {
  /* @ngInject*/

  constructor ($q, $mdDialog, $mdToast, job, ManageJobs, supervisors, $window, Users, Auth) {
    this.$q = $q
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$window = $window
    // TODO - find a better inheritance pattern
    this.mj = ManageJobs
    this.job = job
    this.Users = Users
    this.Auth = Auth
    if (job.company_name.includes('Lyft')) {
      this.lyftCompany = true
    }
    this.showConfirmation = false
    this.formSubmitted = false
    this.title = this.job.title
    this.supervisor = { sendAccount: true, userType: 'CLIENT' }
    this.job.description
    this.batchSize = this.job.batch_size
    this.overFlow = this.job.overflow
    this.is_local_fill = this.job.is_local_fill
    this.batchChanged = false
    this.overflowChanged = false
    this.enterPhone = false
    this.phoenixExperience = false
    this.isApplication = this.job.is_application

    this.description = this.job.description
    this.notes = this.job.notes
    this.arrivalInstructions = this.job.arrival_instructions
    this.alreadyStarted = false
    this.previousStart = new Date(moment.tz(this.job.start_date_time, this.job.timezone).format('lll'))
    this.start = this.previousStart
    let currentDateLocalTime = moment().tz(this.job.timezone)
    this.jobStartLocalTime = moment.tz(this.job.start_date_time, this.job.timezone);
    if (currentDateLocalTime.isAfter(this.jobStartLocalTime)) this.alreadyStarted = true
    this.previousEnd = new Date(moment.tz(this.job.end_date_time, this.job.timezone).format('lll'))
    this.end = this.previousEnd
    this.timezone = moment().tz(this.job.timezone).format('z')
    this.supervisors = supervisors
    this.ccUsers = []
    if (this.job.ccUsers) {
      let idArray = this.job.ccUsers.split(',')
      this.ccUsers = idArray.map((supervisorId) => find(propEq('id', parseInt(supervisorId)))(this.supervisors))
      this.ccUsers = this.ccUsers.filter((value) => !!value)
    }

    this.days = [
      { name: 'Su', value: 1 },
      { name: 'M', value: 2 },
      { name: 'T', value: 4 },
      { name: 'W', value: 8 },
      { name: 'Th', value: 16 },
      { name: 'F', value: 32 },
      { name: 'S', value: 64 }
    ]
    decodeDayMask(this.job.days, this.days)
    this.searchText = this.getAddrString(this.job)
    
    this.getFeatureFlags()
  }

  getFeatureFlags () {
    const attributes = { company_id: this.job.company_internal_id }

    this.Auth.splitClient
      .ready()
      .then(() => {
        this.phoenixExperience = false
      })
      .catch(() => {
        console.log('Error Initializing Split.io')
      })
  }

  close () {
    this.$mdDialog.cancel()
  }

  validateStartDate() {
    this.jobForm.startDatePicker.$error = {};
    this.jobForm.startDatePicker.$invalid = false; 

    // The dates coming from the page appear to be in the users local TZ
    // They should probably be in UTC and just presented differently but...
    // Anyways, I want to fiddle with manage jobs as little as possible so 
    // instead of fixing that (and potentially introducing more bugs) we'll 
    // convert the new start and end date times to TZ of job, but preserve the
    // time value. (second arg of tz is 'keepLocalTime?')
    let startDate = moment(this.start).tz(this.job.timezone, true);
    let endDate = moment(this.end).tz(this.job.timezone, true);

    // Get the current time in the timezone of the job so we can 
    // prevent user from setting start date/time to before the current date
    let currentDateLocalTime = moment().tz(this.job.timezone);
    if (startDate.isBefore(currentDateLocalTime)) {
      this.jobForm.startDatePicker.$error = { startDateBeforeNow: true };
      this.jobForm.startDatePicker.$invalid = true;
    }
    
    // Prevent user from setting start date/time to after end date/time
    if (startDate.isAfter(endDate)) {
      this.jobForm.startDatePicker.$error = { startDateLaterThanEnd: true };
      this.jobForm.startDatePicker.$invalid = true;
    }
  }
  
  validateEndDate() {
    this.jobForm.endDatePicker.$error = {};
    this.jobForm.endDatePicker.$invalid = false;
    
    // The dates coming from the page appear to be in the users local TZ
    // They should probably be in UTC and just presented differently but...
    // Anyways, I want to fiddle with manage jobs as little as possible so 
    // instead of fixing that (and potentially introducing more bugs) we'll 
    // convert the new start and end date times to TZ of job, but preserve the
    // time value. (second arg of tz is 'keepLocalTime?')
    let startDate = moment(this.start).tz(this.job.timezone, true);
    let endDate = moment(this.end).tz(this.job.timezone, true);
  
      
    // Get the current time in the timezone of the job so we can 
    // prevent user from setting end date/time to before the start date/time
    if (endDate.isBefore(startDate)) {
      this.jobForm.endDatePicker.$error = { endDateBeoreStart: true };
      this.jobForm.endDatePicker.$invalid = true;
    }
    
    let currentDateLocalTime = moment().tz(this.job.timezone);
    // Prevent user from setting end date/time to before the current date/time
    if (endDate.isBefore(currentDateLocalTime)) {
      this.jobForm.endDatePicker.$error = { endBeforeNow: true };
      this.jobForm.endDatePicker.$invalid = true;
    }
  }

  confirmForm () {
    if (this.needsConfirmationPrompt()) {
      this.showConfirmationPrompt()
    } else {
      this.updateJob()
    }
  }
  // BW-630
  isForkedJob(job) {
    return (!!this.job.forked_from)
  }

  updateJob () {
    this.formSubmitted = true
    let days = encodeDayMask(this.days)
    let jobDetails = {
      job_id: this.job.job_id,
      title: this.title,
      supervisor: this.job.supervisor_user_id, 
      notifications: this.ccUsers.length ? pluck('id', this.ccUsers) : null, // comma separated user ids of company users that will be added to the cc list of job filled emails and selection reminders.
      startDate: moment(this.start).format('MM/DD/YYYY'),
      startTime: moment(this.start).format('h:mm A'),
      endDate: moment(this.end).format('MM/DD/YYYY'),
      endTime: moment(this.end).format('h:mm A'),
      notes: this.notes,
      description: this.description,
      arrival_instructions: this.arrivalInstructions,
      days,
      address_latitude: this.job.address_latitude,
      address_longitude: this.job.address_longitude,
      address: this.job.address,
      city: this.job.city,
      state: this.job.state,
      zipcode: this.job.zipcode,
      overflow: Number(this.overFlow),
      batch_size: this.batchSize,
      is_local_fill: this.is_local_fill
    }

    this.mj.updateDetails(jobDetails)
      .then(response => {
        return this.$mdDialog.hide({message: response.data, jobDetails})
      })
      .catch(response => {
        this.formSubmitted = false
        return this.$mdDialog.hide({message: response.data.reason, jobDetails: null})
      })
  }

  showConfirmationPrompt () {
    this.showConfirmation = true
    this.startDate = moment(this.start).format('MM/DD/YYYY')
    this.startTime = moment(this.start).format('h:mm A')
    this.endDate = moment(this.end).format('MM/DD/YYYY')
    this.endTime = moment(this.end).format('h:mm A')
    this.selectedDays = this.days.filter(day => day.selected).map(day => dayNames[day.name]).join(', ')
  }

  confirmationCancel () {
    this.showConfirmation = false
  }

  needsConfirmationPrompt () {
    return this.previousStart !== this.start || this.previousEnd !== this.end || this.job.days !== encodeDayMask(this.days)
  }

  getFauxEmail () {
    let email = Math.random().toString(36).substr(2, 10) + '@fake.fake'
    this.supervisor.username = email
    this.supervisor.sendAccount = false
  }

  needsPhone (supervisorId) {
    let supe = find(propEq('id', supervisorId))(this.supervisors)
    if (!supe.phone_number) {
      this.enterPhone = true
      this.supervisor = supe
      this.jobForm.supervisorNewNumber.$error = true
      this.jobForm.$invalid = true
      return
    }
    this.enterPhone = false
  }

  updateSupervisor () {
    this.Users.updateSupervisor({
      userId: this.job.supervisor_id,
      phoneNumber: '1' + this.supervisor.phone_number
    })
      .then(() => {
        this.$mdToast.showSimple('Supervisor Number Saved!')
        this.enterPhone = false
        this.jobForm.supervisorNewNumber.$error = false
        this.jobForm.$invalid = false
      })
      .catch((err) => {
        if (!err) return
        this.$mdToast.showSimple('Error Saving Number')
      })
  }

  createChip (chip) {
    if (propIs(Object, chip)) {
      return chip
    }

    // Otherwise, create a new one
    return { first_name: chip, type: 'new' }
  }

  addSupervisor () {
    this.newSupervisor = true
  }

  removeSupervisor () {
    this.newSupervisor = false
  }

  // Return default value for address input after selecting an exiting template.
  getAddrString (job) {
    return `${job.address}, ${job.city}, ${job.state}, United States`
  }

  queryAddress (input) {
    let def = this.$q.defer()
    let types = [
      'address'
    ]
    this.AutocompleteService = new this.$window.google.maps.places.AutocompleteService()
    this.AutocompleteService.getPlacePredictions({input, types}, (results, status) => {
      if (status !== 'OK') return def.reject(status)
      def.resolve(results)
    })

    return def.promise
  }

  /**
   * Get address components and minimum wage for a given place.
   */
  placeDetails () {
    let def = this.$q.defer()
    this.jobForm.address.$error = {custom: false}
    this.PlacesService = new this.$window.google.maps.places.PlacesService(document.getElementById('places-div'))
    if (!this.selectedPlace || !this.selectedPlace.place_id) {
      this.jobForm.address.$error = {selectMatch: true}
      return def.reject('No valid place selected.')
    }
    this.PlacesService.getDetails({placeId: this.selectedPlace.place_id}, (results, status) => {
      if (status !== 'OK') return def.reject(status)

      let streetNumber

      // Parse address results from places API. Massage for template endpoint.
      results.address_components.forEach((x) => {
        var type = head(prop('types', x))
        if (type === 'street_number') streetNumber = x.long_name
        if (type === 'route') this.job.street = x.long_name
        if (type === 'locality') this.job.city = x.long_name
        if (type === 'country') this.job.country = x.long_name
        if (type === 'administrative_area_level_1') this.job.state = x.short_name
        if (type === 'administrative_area_level_2') this.job.county = x.long_name
        if (type === 'street_number') this.job.street_number = x.long_name
        if (type === 'postal_code') this.job.zipcode = x.long_name
      })

      // Ensure address actually has a street number.
      const hasStreet = pipe(
        prop('address_components'),
        pluck('types'),
        flatten,
        both(contains('street_number'), contains('route'))
      )(results)

      const validAddress = complement(anyPass([
        () => empty(this.job.street),
        () => empty(this.job.city),
        () => empty(this.job.country),
        () => empty(this.job.zipcode),
        () => empty(this.job.state)
      ]))

      // Weird exception for pier addresses.
      const pier = match(/^pier \d*/i, this.selectedPlace.description)

      if ((!hasStreet && empty(pier)) || !validAddress) {
        this.jobForm.address.$error = {custom: true}
        return def.reject(status)
      }

      delete this.jobForm.address.$error
      this.job.address = !empty(pier) ? pier[0] : `${streetNumber} ${this.job.street}`
      this.job.address_latitude = results.geometry.location.lat()
      this.job.address_longitude = results.geometry.location.lng()

      // Recalculate minimum wage based on time and place.
      // this.minimumWage = this.Wages.getMinimumWage(new Date(), 500, this.job.city, this.job.county, this.job.state)
      // if (this.job.wage < this.minimumWage) {
      //   this.job.wage = this.minimumWage
      // }
      def.resolve(results)
    })

    return def.promise
  }
}

export default manageDetailsCtrl